const moduleMap = {
	"./docControlFederatedComponent": () => {
		return Promise.all([__webpack_require__.e(8631), __webpack_require__.e(3580), __webpack_require__.e(1492), __webpack_require__.e(4145), __webpack_require__.e(2339), __webpack_require__.e(3434), __webpack_require__.e(9872), __webpack_require__.e(4465), __webpack_require__.e(9610), __webpack_require__.e(4951), __webpack_require__.e(7877), __webpack_require__.e(7867)]).then(() => (() => ((__webpack_require__(9323)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});